<template>
  <router-view />
</template>

<script>
export default {
  name: 'BaseWrapper'
};
</script>
